import { c as _c } from "react/compiler-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import IconQuality from 'components/icons/iconQuality';
const SuccessMessage = t0 => {
  const $ = _c(15);
  const {
    onClick,
    text,
    bodyText,
    linkText,
    orderSwatchesAsFirstLevel
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="mb-4"><IconQuality /></div>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== text) {
    t2 = <p className="text-xl font-bold mb-4">{text}</p>;
    $[1] = text;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== bodyText) {
    t3 = <p className="text-sm text-white mb-12">{bodyText}</p>;
    $[3] = bodyText;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== onClick || $[6] !== orderSwatchesAsFirstLevel) {
    t4 = () => onClick(orderSwatchesAsFirstLevel);
    $[5] = onClick;
    $[6] = orderSwatchesAsFirstLevel;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== linkText || $[9] !== t4) {
    t5 = <span className="text-base font-bold hover:cursor-pointer" onClick={t4}>{linkText}</span>;
    $[8] = linkText;
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== t2 || $[12] !== t3 || $[13] !== t5) {
    t6 = <div className="items-center bg-brand text-white flex flex-col h-screen justify-center p-12 text-center md:absolute md:left-0 md:top-0 md:right-0 md:bottom-0">{t1}{t2}{t3}{t5}</div>;
    $[11] = t2;
    $[12] = t3;
    $[13] = t5;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  return t6;
};
SuccessMessage.propTypes = {
  onClick: PropTypes.func,
  text: PropTypes.string,
  bodyText: PropTypes.string,
  linkText: PropTypes.string,
  orderSwatchesAsFirstLevel: PropTypes.func
};
export default SuccessMessage;